export const TABLE_ROWS = [
  {
    id: 1,
    title: 'Прирост дополнительных уникальных показов',
    isBigImage: true,
  },
  {
    id: 3,
    title: 'Продвижение на карте',
    isBigImage: false,
    content: [
      {
        isText: false,
        value: 'error-circle',
      },
      {
        isText: false,
        value: 'error-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
    ],
  },
  {
    id: 4,
    title: 'Продвижение в рекомендациях',
    isBigImage: true,
  },
  {
    id: 5,
    title: 'Карточка объекта',
    isBigImage: false,
    content: [
      {
        isText: true,
        value: 'Обычная',
      },
      {
        isText: true,
        value: 'Обычная',
      },
      {
        isText: true,
        value: 'Большая',
      },
      {
        isText: true,
        value: 'Большая',
      },
    ],
  },
  {
    id: 6,
    title: 'Фотографии на карточке',
    isBigImage: false,
    content: [
      {
        isText: false,
        value: 'one-house',
      },
      {
        isText: false,
        value: 'one-house',
      },
      {
        isText: false,
        value: 'x4-house',
      },
      {
        isText: false,
        value: 'x4-house',
      },
    ],
  },
  {
    id: 7,
    title: 'Уникальный заголовок',
    isBigImage: false,
    content: [
      {
        isText: false,
        value: 'error-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
    ],
  },
  {
    id: 8,
    title: 'Брендирование в поиске',
    isBigImage: false,
    content: [
      {
        isText: false,
        value: 'error-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
      {
        isText: false,
        value: 'success-circle',
      },
    ],
  },
];
